import axios from "axios";
import { apiURL } from "../config/config";

const getAuthConfig = () => {
  const token = localStorage.getItem("token");

  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

export const listAnnouncements = async ({
  status = "",
  page = 1,
  limit = 10,
  search = "",
} = {}) => {
  const response = await axios.get(`${apiURL}announcements`, {
    ...getAuthConfig(),
    params: {
      ...(status ? { status } : {}),
      page,
      limit,
      ...(search ? { search } : {}),
    },
  });

  return response.data;
};

export const getAnnouncementDetail = async (id) => {
  const response = await axios.get(`${apiURL}announcements/${id}`, getAuthConfig());
  return response.data;
};

export const createAnnouncement = async (payload) => {
  const response = await axios.post(
    `${apiURL}announcements`,
    payload,
    getAuthConfig()
  );
  return response.data;
};

export const updateAnnouncement = async (id, payload) => {
  const response = await axios.put(
    `${apiURL}announcements/${id}`,
    payload,
    getAuthConfig()
  );
  return response.data;
};

export const updateAnnouncementStatus = async (id, status) => {
  const response = await axios.patch(
    `${apiURL}announcements/${id}/status`,
    { status },
    getAuthConfig()
  );
  return response.data;
};

export const republishAnnouncement = async (id) => {
  const response = await axios.post(
    `${apiURL}announcements/${id}/republish`,
    {},
    getAuthConfig()
  );
  return response.data;
};

export const deleteAnnouncement = async (id) => {
  const response = await axios.delete(
    `${apiURL}announcements/${id}`,
    getAuthConfig()
  );
  return response.data;
};

export const getActivePopupAnnouncements = async (pagePath) => {
  const response = await axios.get(`${apiURL}announcements/active-popup`, {
    ...getAuthConfig(),
    params: {
      pagePath,
    },
  });

  return response.data;
};

export const dismissAnnouncement = async (id, pagePath) => {
  const response = await axios.post(
    `${apiURL}announcements/${id}/dismiss`,
    { pagePath },
    getAuthConfig()
  );
  return response.data;
};

export const acknowledgeAnnouncement = async (id, pagePath) => {
  const response = await axios.post(
    `${apiURL}announcements/${id}/acknowledge`,
    { pagePath },
    getAuthConfig()
  );
  return response.data;
};

export const getAnnouncementLogs = async (id, { page = 1, limit = 20 } = {}) => {
  const response = await axios.get(`${apiURL}announcements/${id}/logs`, {
    ...getAuthConfig(),
    params: {
      page,
      limit,
    },
  });

  return response.data;
};

export const getAnnouncementUserOptions = async () => {
  const response = await axios.get(`${apiURL}users`, getAuthConfig());
  return response.data;
};
